require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-region-europa-y-asia-central.json") })
        }
      }, "path---es-mx-region-europa-y-asia-central");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-region-europa-y-asia-central!./.cache/json/es-mx-region-europa-y-asia-central.json
// module id = 905
// module chunks = 231608221292675